import { render, staticRenderFns } from "./AdditionalInfo.vue?vue&type=template&id=70f3035c&scoped=true"
import script from "./AdditionalInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalInfo.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInfo.vue?vue&type=style&index=0&id=70f3035c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f3035c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f3035c')) {
      api.createRecord('70f3035c', component.options)
    } else {
      api.reload('70f3035c', component.options)
    }
    module.hot.accept("./AdditionalInfo.vue?vue&type=template&id=70f3035c&scoped=true", function () {
      api.rerender('70f3035c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/attendance/components/tabs/AdditionalInfo.vue"
export default component.exports